import { ControleGabinete, TipoControle } from '../modelo';

interface DisponibilidadeEscaninhos {
    redator?: boolean;
    votoVencido?: boolean;
    pauta?: boolean;
}

const chave = (gabinete: string) => `GE-disponibilidade-escaninhos-${gabinete}`;

export function lerDisponibilidadeEscaninhos(gabinete?: string): DisponibilidadeEscaninhos | undefined {
    if (!gabinete) return undefined;
    try {
        const valor = JSON.parse(localStorage.getItem(chave(gabinete)) || 'null');
        if (valor && typeof valor === 'object') {
            return {
                redator: typeof valor.redator === 'boolean' ? valor.redator : undefined,
                votoVencido: typeof valor.votoVencido === 'boolean' ? valor.votoVencido : undefined,
                pauta: typeof valor.pauta === 'boolean' ? valor.pauta : undefined,
            };
        }
    } catch {
        // Cache indisponível: aguarda a configuração retornada pelo servidor.
    }
    return undefined;
}

export function salvarDisponibilidadeEscaninhos(gabinete: string, controles: ControleGabinete[]): void {
    if (!gabinete) return;
    try {
        localStorage.setItem(chave(gabinete), JSON.stringify({
            ...lerDisponibilidadeEscaninhos(gabinete),
            redator: controles.some(controle => controle.tipo.id === TipoControle.REDATORDESIGNADO),
            votoVencido: controles.some(controle => controle.tipo.id === TipoControle.VOTOVENCIDO),
        }));
    } catch {
        // Falhas no cache não devem interromper o carregamento dos controles.
    }
}

export function salvarDisponibilidadePauta(gabinete: string, pauta: boolean): void {
    if (!gabinete) return;
    try {
        localStorage.setItem(chave(gabinete), JSON.stringify({
            ...lerDisponibilidadeEscaninhos(gabinete),
            pauta,
        }));
    } catch {
        // Falhas no cache não devem interromper a exibição do menu.
    }
}
